module.exports = __webpack_public_path__ + "static/media/locatorx.e7f2e337.png";